<template>
  <section id="contact" class="contact" >
    <div class="container" data-aos="fade-up">
      <div class="row">
        <div class="col-lg-5 align-items-stretch" style="text-align: center;">
          <img src="assets/img/support.png" alt="dashboard" width="250">
        </div>

        <div class="col-lg-7 mt-5 mt-lg-0 align-items-stretch support">
          <div style="padding-top: 50px">
            <h5 class="service">The very service comes to you through a web portal and no software installation or deployment costs with it; on top of that, our service hotline is available 24/7 to support you for any needs. We assure you of our best services.</h5>
          </div>
          <a href="javascript:" class="btn btn-primary" @click="showContactUs">Contact Us</a>
        </div>
      </div>
    </div>
  </section>
  <!-- End Contact Section -->
</template>
<script>
export default {
  name: "CorporateTopUp",
  methods: {
    showContactUs() {
      this.$store.commit('showContactUs',true);
    }
  }
};
</script>

<style scoped lang="scss">
.service {
  color: #004a59;
  font-weight: bold;
  line-height: 1.5em;
}
.support a{
  margin-top: 10px;
  background: #004a59;
  border: none;
  width: 220px;
  padding: 18px;
  border-radius: 35px;
  text-transform: uppercase;
  font-weight: bold;
}
</style>
